export default __webpack_public_path__ + "static/media/jenkins_scaled.3c4e3422.png";